import React from 'react';
import iconCardLoader from '../../assets/icons/icons_card_loader.svg';

interface Props {
  children: React.ReactNode;
  loading: boolean;
  loader?: React.FC;
  className?: string;
}

interface DefaultLoaderProps {
  className?: string;
}
const DefaultLoader: React.FC<DefaultLoaderProps> = ({ className }) => (<img className={['animate-pulse', className].filter(Boolean).join(' ')} src={iconCardLoader} alt="loading" />);

// renders loader if loading, otherwise renders children
const MiniLoader: React.FC<Props> = ({
  children, loading = false, loader: Loader = DefaultLoader, className,
}) => (
  <div>
    {loading ? <Loader className={className} /> : children}
  </div>
);
export default MiniLoader;
